import {
  number,
  optional,
  string,
  boolean,
  type InferOutput,
  object
} from 'valibot'

import {
  createSorterSchema,
  ITEM_UNITS_SORT_KEYS
} from '@/features/shared/models'

export const ItemUnitsSearchSchema = object({
  page: optional(number()),
  take: optional(number()),
  ...createSorterSchema(ITEM_UNITS_SORT_KEYS),
  name: optional(string()), // 項目名
  enable: optional(boolean()) // 有効/無効フラグ
})

export type ItemUnitsSearch = InferOutput<typeof ItemUnitsSearchSchema>
